export default {
  clearAll: {
    id: 'admin_generic_component_form_algolia_facets_clear_all',
    defaultMessage: 'Clear all filters',
  },
}
